// extracted by mini-css-extract-plugin
export var container = "_3r-1";
export var editor = "_3r-2";
export var resizable = "_3r-3";
export var wrapper = "_3r-0";